"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.settingsProviderActions = exports.initialState = void 0;
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const slices_1 = require("../../utils/@reduxjs/slices");
const index_1 = require("../../utils/index");
const REDUCER_KEY = 'settingsProvider';
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    data: {
        fetchItem: { ...index_1.requestInitialState },
    },
});
const settingsStateSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        getSettingsData(state, __payload) {
            state.data.fetchItem.loading = true;
            state.data.fetchItem.error = null;
        },
        getSettingsDataSuccess(state, { payload }) {
            state.data.fetchItem.loading = false;
            state.data.fetchItem.error = null;
            state.data.entry = payload;
        },
        getSettingsDataError(state, { payload }) {
            state.data.fetchItem.loading = false;
            state.data.fetchItem.error = payload;
        },
        setSettingsData(state, _action) {
            state.data.fetchItem.loading = true;
            state.data.fetchItem.error = null;
        },
        setSettingsDataSuccess(state, { payload }) {
            state.data.fetchItem.loading = false;
            state.data.fetchItem.error = null;
            if (state.data.entry) {
                state.data.entry = { ...state.data.entry, ...payload };
            }
        },
        setSettingsDataError(state, { payload }) {
            state.data.fetchItem.loading = false;
            state.data.fetchItem.error = payload;
        },
    },
});
exports.settingsProviderActions = settingsStateSlice.actions, exports.reducer = settingsStateSlice.reducer, exports.sliceKey = settingsStateSlice.name;
//# sourceMappingURL=slice.js.map